import { Box, Typography } from '@mui/material'

import { Maybe } from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'
import { MembershipSubscriptionProduct } from '@/core/membership'

import {
  MembershipEditForm,
  MembershipEditFormProps,
} from './MembershipEditForm'
export * from './fragments'

export type State = {
  artistId: string
  product?: Maybe<MembershipSubscriptionProduct>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: MembershipEditFormProps['onSubmit']
}

export const ConsoleMembershipEditTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { routerNames, routerPages, generatePath, router } =
    useRouter<{ planId: string }>()
  const { t } = useTranslation('consoleMembershipEdit')

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleMembershipEdit} />

      <ConsoleBaseLayout
        header={{
          back: true,
          defaultBackPage: generatePath(routerPages.ConsoleMembershipDetail, {
            planId: router.query.planId ?? '#',
          }),
          title: t('title'),
        }}
      >
        <Box sx={{ px: 5, pt: 5 }}>
          <Typography variant="h5">{t('membershipDesc')}</Typography>
          <Typography
            component="p"
            variant="caption"
            color="text.secondary"
            sx={{ pt: 2 }}
          >
            {t('enterMembershipDesc')}
          </Typography>
        </Box>
        <MembershipEditForm product={state.product} onSubmit={onSubmit} />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
